import React, { forwardRef } from 'react';
import {
  minWidth,
  maxWidth,
  minHeight,
  maxHeight,
  flexWrap,
  flexGrow,
  flexDirection,
  alignItems,
  justifyContent,
  display,
  textAlign,
  flexShrink,
  overflow,
  MinWidthProps,
  MaxWidthProps,
  MinHeightProps,
  MaxHeightProps,
  FlexWrapProps,
  FlexGrowProps,
  FlexShrinkProps,
  FlexDirectionProps,
  AlignItemsProps,
  TextAlignProps,
  JustifyContentProps,
  DisplayProps,
  OverflowProps,
} from 'styled-system';
import styled from 'styled-components';
import { Box, IBoxProps } from '../Container/Box.component';

interface FlexTypes {
  sticky?: boolean;
  context?: string;
  subject?: string;
  className?: string;
  children?: React.ReactNode;
  name?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

interface IBaseFlexBoxProps extends FlexTypes, IBoxProps {}

export interface IFlexProps
  extends IBaseFlexBoxProps,
    MinWidthProps,
    MaxWidthProps,
    MinHeightProps,
    MaxHeightProps,
    FlexWrapProps,
    FlexGrowProps,
    FlexShrinkProps,
    FlexDirectionProps,
    AlignItemsProps,
    TextAlignProps,
    JustifyContentProps,
    DisplayProps,
    OverflowProps {}

const FlexBox = forwardRef<HTMLDivElement, IBaseFlexBoxProps>((props, ref) => (
  <Box ref={ref} style={props.style} {...props} />
));

FlexBox.displayName = 'FlexBox';

export const Flex = styled(FlexBox)<IFlexProps>`
  display: flex;
  box-sizing: border-box;
  ${minWidth}
  ${maxWidth}
  ${minHeight}
  ${maxHeight}
  ${flexWrap}
  ${flexGrow}
  ${flexShrink}
  ${flexDirection}
  ${alignItems}
  ${textAlign}
  ${justifyContent}
  ${display}
  ${overflow}
`;

Flex.displayName = 'Flex';

export const FlexColumn = ({ ...props }) => <Flex {...props} {...{ flexDirection: 'column' }} />;

export const InlineFlex = styled(Flex)`
  display: inline-flex;
  gap: 4px;
`;
